import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { HomeComponent } from 'app/views/home/home.component';
import { SearchComponent } from 'app/views/search/search.component';
import { TopicComponent } from 'app/views/topic/topic.component';
import { LoginComponent } from 'app/views/login/login.component';
import { StoryboardComponent } from 'app/views/storyboard/storyboard.component';
import { GeneralViewComponent } from 'app/views/general-view/general-view.component';
import { AdminComponent } from 'app/views/admin/admin.component';
import { FileComponent } from 'app/views/file/file.component';
import { OnboardingComponent } from 'app/views/onboarding/onboarding.component';
import { UsefulLinksComponent } from 'app/views/useful-links/useful-links.component';
import { StadiumComponent } from 'app/views/stadium/stadium.component';
import { StadiumAdminComponent } from 'app/views/stadium-admin/stadium-admin.component';
import { TopicsComponent } from 'app/views/topics/topics.component';
import { StoryboardsComponent } from 'app/views/storyboards/storyboards.component';
import { SearchAdminComponent } from 'app/views/search-admin/search-admin.component';
import { FilesAdminComponent } from 'app/views/files-admin/files-admin.component';
import { CompetitionComponent } from 'app/views/competition/competition.component';
import { FilesComponent } from 'app/views/files/files.component';
import { CompetitionsResolver } from 'app/guards/competitions.guard';
import { CompetitionResolver } from 'app/guards/competition.guard';
import { AdminResolver } from 'app/guards/admin.guard';
import { StoryboardsViewComponent } from 'app/views/storyboards-view/storyboards-view.component';

const routes: Routes = [
  {
    path: 'admin',
    resolve: [
      AdminResolver,
      CompetitionsResolver
    ],
    children: [
      {
        path: '',
        component: GeneralViewComponent,
        children: [
          {
            path: 'competition/:id',
            resolve: [CompetitionResolver],
            children: [
              {
                path: 'file/:id',
                component: FileComponent
              }
            ]
          },
          {
            path: 'competition/:id',
            component: AdminComponent,
            resolve: [CompetitionResolver],
            children: [
              {
                path: 'onboarding',
                component: OnboardingComponent
              },
              {
                path: 'stadium',
                component: StadiumAdminComponent
              },
              {
                path: 'storyboards',
                component: StoryboardsComponent
              },
              {
                path: 'topics',
                component: TopicsComponent
              },
              {
                path: 'files',
                component: FilesAdminComponent
              },
              {
                path: 'useful-links',
                component: UsefulLinksComponent
              }
            ]
          },
          {
            path: 'search',
            component: SearchAdminComponent,
          },
          {
            path: 'search/file/:id',
            component: FileComponent,
          },
          {
            path: 'search/storyboard/:id',
            component: FileComponent,
          },
          {
            path: 'search/topic/:id',
            component: FileComponent,
          },
          {
            path: 'search/stadium',
            component: StadiumAdminComponent
          },
          {
            path: '',
            component: AdminComponent
          }
        ]
      },
      {
        path: 'competition/:id',
        resolve: [CompetitionResolver],
        children: [
          {
            path: 'files/file/:id',
            component: FileComponent
          },
          {
            path: 'file/:id',
            component: FileComponent
          },
          {
            path: 'storyboards/storyboard/:id',
            component: StoryboardComponent
          },
          {
            path: 'storyboards/file/:id',
            component: FileComponent
          },
          {
            path: 'onboarding/file/:id',
            component: FileComponent
          },
          {
            path: 'stadium/file/:id',
            component: FileComponent
          },
          {
            path: 'topics/file/:id',
            component: FileComponent
          },
          {
            path: '**',
            redirectTo: 'onboarding'
          }
        ]
      },
      {
        path: 'competition',
        component: CompetitionComponent
      }
    ]
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'competition',
    component: GeneralViewComponent,
    resolve: [
      CompetitionsResolver
    ]
  },
  {
    path: 'admin',
    redirectTo: 'admin'
  },
  {
    path: 'admin/competition',
    redirectTo: 'admin'
  },
  {
    path: 'competition/admin',
    redirectTo: 'admin'
  },
  {
    path: ':id',
    resolve: [
      CompetitionsResolver,
      CompetitionResolver
    ],
    children: [
      {
        path: '',
        component: GeneralViewComponent,
        children: [
          {
            path: '',
            component: HomeComponent
          },
          {
            path: 'search',
            component: SearchComponent,
          },
          {
            path: 'topic/:id',
            component: TopicComponent
          },
          {
            path: 'storyboards',
            component: StoryboardsViewComponent
          }
        ]
      },
      {
        path: '',
        component: GeneralViewComponent,
        children: [
          {
            path: 'search/topic/:id',
            component: TopicComponent
          }
        ]
      },
      {
        path: 'storyboards/storyboard/:id',
        component: StoryboardComponent
      },
      {
        path: 'storyboard/:id',
        component: StoryboardComponent
      },
      {
        path: 'storyboards/file/:id',
        component: FileComponent
      },
      {
        path: 'file/:id',
        component: FileComponent
      },
      {
        path: 'topic/:id/file/:id',
        component: FileComponent
      },
      {
        path: 'search/topic/:id/file/:id',
        component: FileComponent
      },
      {
        path: 'search/file/:id',
        component: FileComponent
      },
      {
        path: 'search/storyboard/:id',
        component: StoryboardComponent
      },
      {
        path: 'files/file/:id',
        component: FileComponent
      },
      {
        path: 'stadium',
        component: StadiumComponent
      },
      {
        path: 'search/stadium',
        component: StadiumComponent
      }
    ]
  },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
